import formatFns from 'date-fns/format';
import {
    aiPhotoGenerationFolderId,
    aiPhotoGenerationLoaderTextVariants,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.constants';
import type { TreeNodeData } from 'reactApp/ui/TreeComponent/TreeNode.types';
import { load } from 'reactApp/utils/print';

export const getAiPhotoGenerationImageFileName = (): string => {
    return formatFns(Date.now(), 'yyyy-mm-dd\u00A0hh.mm.ss');
};

export const downloadAiPhotoGenerationImage = (data: Uint8Array, fileName: string) => {
    if (!data || !fileName) {
        return;
    }

    const blob = new Blob([data], { type: 'image/jpeg' });
    load(blob, fileName);
};

export const checkAiPhotoGenerationExists = (folders: TreeNodeData[]) => folders.some((folder) => folder.id === aiPhotoGenerationFolderId);

export const getAiPhotoGenerationRandomVariantExcluding = (
    current?: aiPhotoGenerationLoaderTextVariants
): aiPhotoGenerationLoaderTextVariants => {
    const variants = Object.values(aiPhotoGenerationLoaderTextVariants).filter((v) => v !== current);
    const randomIndex = Math.floor(Math.random() * variants.length);
    return variants[randomIndex] as aiPhotoGenerationLoaderTextVariants;
};

export const getAiPhotoGenerationTime = (startTime?: number | null) => {
    if (!startTime) {
        return null;
    }

    const endTime = performance.now() - startTime;
    return Math.round(endTime / 1000);
};
